import { render, staticRenderFns } from "./prodPriceDetails.vue?vue&type=template&id=00ba4c8a&"
import script from "./prodPriceDetails.vue?vue&type=script&lang=js&"
export * from "./prodPriceDetails.vue?vue&type=script&lang=js&"
import style0 from "./prodPriceDetails.vue?vue&type=style&index=0&id=00ba4c8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports